
import { Suspense, lazy } from "react";
import "./Home.css";

import jmk2025 from '../../assets/images/JMK Re 25.jpg';

import jmkReport from '../../assets/images/jmk.jpeg';
import crisilBridge from '../../assets/images/crisilBridge.webp';
import gautamSolarRank from '../../assets/images/gautamSolarRank.webp';
import VideoFirst from "../../component/videofirst/VideoFirst";

import New1 from "../../assets/images/new1.jpeg"
import New2 from "../../assets/images/new2.jpg"

import FAQ from "../../component/faq/FAQ";
import { Helmet } from "react-helmet";
import WhyChooseGautamSolar from "../../component/solarpanel/SolarPanel";
import AmongTopSolar from "../../component/amongtopsolar/AmongTopSolar";

// Lazy-loaded components
const VideoSecond = lazy(() => import("../../component/videosecond/VideoSecond"));
// const AmongTopSolar = lazy(() => import("../../component/amongtopsolar/AmongTopSolar"));
// const AmongTopSolar = lazy(() => import("../../component/amongtopsolar/AmongTopSolar"));
const SolarMod = lazy(() => import("../../component/solarmod/SolarMod"));
const Factories = lazy(() => import("../../component/factories/Factories"));
const SliderFirst = lazy(() => import("../../component/sliderfirst/SliderFirst"));
const ContactBox = lazy(() => import("../../component/enquiry/ContactBox"));



function Home() {
  const topSolar = [
    { title: ' JMK Research & Analytics', desc: 'RE Update Q2 2025', img: jmk2025, alt: 'Top 10 Solar ' },
    { title: ' JMK Research & Analytics', desc: ' Gautam Solar in India’s Top 10 Module Makers – FY 2025.', img: jmkReport, alt: 'Top 10 solar module' },
    { title: ' CRISIL Bridge To India', desc: 'India PV Module Intelligence Brief | Q4 2024', img: crisilBridge, alt: 'Top 10 solar ' },
    { title: ' JMK 2024', desc: 'RE Update Q4 2024', img: gautamSolarRank, alt: 'Top 10 Solar ' },
  ]


  const topSolar2 = [
    { img: New1 },
    { img: New2 },
  ]

  const heading = "AMONG INDIA'S";
  const subHeading = "TOP 10 SOLAR MODULE MANUFACTURERS"

  return (
    <>
      <Helmet>
        <title>Top 10 Solar Module Manufacturers company in india</title>
        <meta
          name="description"
          content="Searching for the Best Top 10 Solar Module Manufacturers company in India? Gautam Solar is among the most reliable solar companies, boasting over 25 years of experience. The company specialises in producing high-efficiency solar modules, including Mono PERC and state-of-the-art N-Type TOPCon panels. "
        />
        <meta
          name="keywords"
          content="Top Solar Module Plant, Top 10 Solar Module Manufacturers company in india, India Solar Manufacturer company, Solar panels, solar manufacturing company in india"
        />
      </Helmet>
      <h1 className="sr-only">AMONG INDIA'S TOP 10 SOLAR MODULE MANUFACTURERS</h1>

      <AmongTopSolar
        topSolar={topSolar2}
        heading="Global Top 30 "
        subHeading="Solar Module Manufacturers"
      />

      <VideoFirst />
      <Suspense
        fallback={
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
            <div className="spinner-border" role="status" style={{ color: '#a20000' }}>
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        }
      >
        <VideoSecond />
        <AmongTopSolar
          heading={heading}
          subHeading={subHeading}
          topSolar={topSolar} />
        <SolarMod />
        <WhyChooseGautamSolar />
        <Factories />
        <SliderFirst />
        <FAQ />
        <ContactBox />
      </Suspense>
    </>
  );
}

export default Home;
